import axios from 'axios';

export const readAllNotifications = async () => {
  return await axios.post(`/notifications/read/all`);
};
